import type { FC } from 'react';
import { lazy, useMemo } from 'react';
import type { BulletinBoardNoticesParams } from 'src/apis/secondary-market-service/types';
import { useBulletinBoardNotices } from 'src/apis/secondary-market-service/use-bulletin-board-notices';
import type { SecondaryMarketServiceRequest } from 'src/apis/secondary-market-service/use-secondary-market-service';
import { PageSpinner } from 'src/components/spinner-container';
import { useBulletinBoardPageParams } from 'src/pages/transport/secondary-trading/overview/common/bulletin-board/use-page-params';

const Page = lazy(() => import('./page'));

export const BulletinBoardNoticeCreate: FC<{
  secondaryMarketService: SecondaryMarketServiceRequest;
}> = ({ secondaryMarketService }) => {
  const params = useBulletinBoardPageParams();

  const transformedParams = useMemo(() => {
    const { start, pageSize } = params.value;
    return {
      offset: start,
      limit: pageSize,
    } satisfies BulletinBoardNoticesParams;
  }, [params.value]);

  const bulletinBoardNotices = useBulletinBoardNotices({
    secondaryMarketService,
    params: transformedParams,
  });

  if (!secondaryMarketService.response || !bulletinBoardNotices.response) {
    return <PageSpinner />;
  }

  return (
    <Page
      secondaryMarketService={secondaryMarketService}
      bulletinBoardNotices={bulletinBoardNotices}
    />
  );
};
